import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 24px',
    backgroundColor: 'white'
  },

  menu: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  title: {
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  }
}))

export default useStyles
